import React, {useContext, useEffect, useRef, useState} from 'react';

import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

import {AutoComplete} from 'primereact/autocomplete';
import {InputNumber} from 'primereact/inputnumber';
import {SongService} from '../services/SongService';
import {Button} from 'primereact/button';
import {InputText} from "primereact/inputtext";
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Fieldset} from "primereact/fieldset";
import {OverlayPanel} from "primereact/overlaypanel";
import SongDistributionChart from "./SongDistributionChart";
import {PlaylistDualView} from "./PlaylistDualView";
import {Toast} from "primereact/toast";
import {durationFromMs, filterNameConcat, setRowNrToPlaylist, playlistTime} from "../utils/PlaylistHelper";
import {PlaylistSaveToStreamingService} from "./PlaylistSaveToStreamingService";
import {Checkbox} from "primereact/checkbox";

export function PlaylistGenerator({incrementPlaylistCounter, spotifyUsers, initPlaylist}) {
    const toast = useRef(null);

    // Fieldset Song Selection
    const [playlistDefinitionSongs, setPlaylistDefinitionSongs] = useState([]);

    // select a song to be added to the playlistDefinition
	const [songs, setSongs] = useState([]);
	const [filteredSongs, setFilteredSongs] = useState(null);
	const [selectedSong, setSelectedSong] = useState(null);
    const [nrReps, setNrReps] = useState(1);

    // select an album and add its songs to the playlistDefinition
    const [albums, setAlbums] = useState([]);
    const [filteredAlbums, setFilteredAlbums] = useState(null);
    const [selectedAlbum, setSelectedAlbum] = useState(null);
    const [nrRepsAlbum, setNrRepsAlbum] = useState(1);

    // Initializer playlist
    const[spotifyInitializerPlaylist, setSpotifyInitializerPlaylist] = useState('');

    // load a playlist and add its songs to the playlistDefinition
    const [spotifyPlaylistSongSelection, setSpotifyPlaylistSongSelection] = useState('');
    const [nrRepsPl, setNrRepsPl] = useState(1);

    // Generator Parameters
    const [plGenDeltaSong, setPlGenDeltaSong] = useState(1);
    const plGenMethodOptions = [{id: 'recursive', displayval: 'Recursive (more uniformly spread)'}, {id: 'random', displayval: 'Random Pick'}];
    const [plGenMethod, setPlGenMethod] = useState(plGenMethodOptions[0]);

    // Filler Parameters
    // const[deltaTimeIn5s, setDeltaTimeIn5s] = useState(90); // for slider
    const[maxTimeInMs, setMaxTimeInMs] = useState(600000);
    const[excludeSkit, setExcludeSkit] = useState(false);
    const[nrSongsByMember, setNrSongsByMember] = useState(0);
    const[minNrSongsBTS, setMinNrSongsBTS] = useState(0);

    // View
    const [showDurationCol, setShowDurationCol] = useState(false);

    // Fieldset Playlist Preview
    const [playlist, setPlaylist] = useState([]);
    const [playlistURL, setPlaylistURL] = useState(null);
    const [editInfo, setEditInfo] = useState({editable: false, spotifyplaylist_id: "undefined", spotifyuser_id: -1, plname:"", pldescription:""});
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [playlistPreviewCollapsed, setPlaylistPreviewCollapsed] = useState(false);
    const op = useRef(null);


	const songservice = new SongService();
	
	useEffect(() => {
        songservice.getSongs().then(data => setSongs(data));
        songservice.getAlbums().then(data => setAlbums(data));
        if(initPlaylist && spotifyInitializerPlaylist ==='') {
            setSpotifyInitializerPlaylist(initPlaylist);
            loadPlaylistFromSpotify(initPlaylist);
        }
    }, []);



    const searchSong = (event) => {
        setTimeout(() => {
            let _filteredSongs;
            if (!event.query.trim().length) {
                _filteredSongs = [...songs];
            }
            else {
                _filteredSongs = songs.filter((song) => {
                    return filterNameConcat(event, song.nameconcat);
                });
            }

            setFilteredSongs(_filteredSongs);
        }, 250);
    }

    const searchAlbum = (event) => {
        setTimeout(() => {
            let _filteredAlbums;
            if (!event.query.trim().length) {
                _filteredAlbums = [...albums];
            }
            else {
                _filteredAlbums = albums.filter((album) => {
                    return filterNameConcat(event, album.nameconcat);
                });
            }
            setFilteredAlbums(_filteredAlbums);
        }, 250);
    }
	
	const addSelectedSong = () => {
        //forceselection ... selected the wrong item (same  nameconcat, diff id, therefore check for id)
		if (selectedSong == null || selectedSong.id == null) {
			
		} else {
			let _playlistDefinitionSongs;
			_playlistDefinitionSongs = [...playlistDefinitionSongs, {pdid:selectedSong.id, song: selectedSong, nr_reps: nrReps}];
			setPlaylistDefinitionSongs(_playlistDefinitionSongs);

            let _songs = songs;
            _songs = _songs.filter(item => item.id !== selectedSong.id);

            setSelectedSong(null);
			setNrReps(1);
            setSongs(_songs);
		}
	}

    const deleteSelectedSong = (rowdata) => {
        let _playlistDefinitionSong = playlistDefinitionSongs.filter(val => rowdata.song.id !== val.song.id);

        if (!songs.find(val => rowdata.song.id === val.id)) {
            let _songs = [...songs, rowdata.song];
            setSongs(_songs);
        }
        setPlaylistDefinitionSongs(_playlistDefinitionSong);

        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Removed Song', life: 1200 });
    }

    const addSelectedAlbum = () => {
        //forceselection ... selected the wrong item (same  nameconcat, diff id, therefore check for id)
        if (selectedAlbum == null || selectedAlbum.id == null) {

        } else {
            let _playlistDefinitionSongs;
            let _songs = songs;

            _playlistDefinitionSongs = [...playlistDefinitionSongs]
            selectedAlbum.tracks.forEach((track) => {
                let songInDefinition = _playlistDefinitionSongs.find(pds => pds.song.id === track.id);
                if(songInDefinition) {
                    _playlistDefinitionSongs = _playlistDefinitionSongs.filter(pds => pds.song.id !== track.id);
                    _playlistDefinitionSongs.push({pdid: songInDefinition.song.id, song: songInDefinition.song, nr_reps: songInDefinition.nr_reps + nrRepsAlbum});
                } else {
                    _playlistDefinitionSongs.push({pdid: track.id, song: track, nr_reps: nrRepsAlbum});
                }
                _songs = _songs.filter(item => item.id !== track.id);
            })

            setPlaylistDefinitionSongs(_playlistDefinitionSongs);
            setSelectedAlbum(null);
            setNrRepsAlbum(1);
            setSongs(_songs);
        }
    }
	
	 const itemTemplate = (item) => {
        return (
            <div className="song-item">
                <img src={`${item.image_url}`} width="16" height="16"/>
                <span> {item.nameconcat}</span>
            </div>
        );
    }

    const imageTemplate2 = (item) => {
        return (
            <div><img src={item.song.image_url} width="24"/></div>
        );
    }

    const durationTemplate = (item) => {
        return(
            <div> {durationFromMs(item.song.duration_ms)}</div>
        )
    }

    // const splitButtonMaxDurationSelection = () => {
    //     let items = [];
    //     for(let i=0; i<5; i++) {
    //         let deltaTimeIn5s = 12 - i*3;
    //         items.push(
    //             {
    //                 label: durationFromMs(1000*(150 + (5*deltaTimeIn5s))),
    //                 icon: 'pi pi-clock',
    //                 command: () => {
    //                     setDeltaTimeIn5s(deltaTimeIn5s);
    //                 },
    //             }
    //         )
    //     }
    //
    //     return <SplitButton label="10:00" icon="pi pi-clock" onClick={ () => setDeltaTimeIn5s(90)} model={items}/>
    // }

    const deltaOptions = [
        {value: 600000, name:durationFromMs(600000)},
        {value: 300000, name:durationFromMs(300000)},
        {value: 240000, name:durationFromMs(240000)},
        {value: 225000, name:durationFromMs(225000)},
        {value: 210000, name:durationFromMs(210000)},
        {value: 195000, name:durationFromMs(195000)},
        {value: 180000, name:durationFromMs(180000)},
        {value: 165000, name:durationFromMs(165000)},
        {value: 150000, name:durationFromMs(150000)},
    ]
    const dropDownMaxDurationSelection = () => {
        return(<Dropdown value={maxTimeInMs} onChange={(e) => setMaxTimeInMs(e.value)}
                  options={deltaOptions} optionLabel="name" optionValue="value"/>)
    }

    // const getMaxDurationMS = () => {
    //     return(1000*(150 + (5*deltaTimeIn5s)))
    // }
	
	const generatePlaylist  = () => {
		// we do not need the arguments, as we have access to everything here anyway?
		// list of Songs
        let allsongs = []
        playlistDefinitionSongs.forEach(song => {
            for(let i = 0; i < song.nr_reps; i++) {
                allsongs.push(song.song);
            }
        })
        setPlaylistURL(null)
        setPlaylistPreviewCollapsed(false);
        let plGenParams = {
            pl_gen_method: plGenMethod.id,
            delta_song: plGenDeltaSong,
        }
        let plFillerParams = {
            max_duration_ms: maxTimeInMs,
            exclude_skit: excludeSkit,
            nr_songs_by_member: nrSongsByMember,
            minimum_nr_songs_bts: minNrSongsBTS
        }

        //     delta_song: int
        songservice.generatePlaylistV2(allsongs, plGenParams, plFillerParams).then(playlist =>
        {
            if(playlist.detail){
                toast.current.show({severity: "error", sticky: true, summary: playlist.detail});
            } else {
                setPlaylist(setRowNrToPlaylist(playlist))
            }
        });
        //songservice.generatePlaylist(allsongs, plGenMethod, plGenDeltaSong).then(playlist => setPlaylist(setRowNrToPlaylist(playlist)));
		// playlistDefinitionArtists.toJSON()
	}


    const clearPlaylistDefinition = () => {
        songservice.getSongs().then(data => setSongs(data));
        songservice.getAlbums().then(data => setAlbums(data));
        setPlaylistDefinitionSongs([]);
        setNrReps(1);
        setNrRepsAlbum(1);
        setNrRepsPl(1);

        setPlaylist([]);
        setPlaylistURL(null);
    }



    const playlistDefinitionPlayistSongs = () => {
        let nrSongs = playlistDefinitionSongs.reduce((partialSum, plDef) => partialSum + plDef.nr_reps, 0 )
        return nrSongs;
    }

    const playlistDefinitionDuration = () => {
        let dur = playlistDefinitionSongs.reduce((partialSum, plDef) => partialSum + plDef.nr_reps*plDef.song.duration_ms, 0 )
        return durationFromMs(dur);
    }



    const onEditorValueChange = (props, value) => {
        let _playlistDefinitionSongs = [...playlistDefinitionSongs];
        for(let i = 0; i < _playlistDefinitionSongs.length; i++) {
            if(_playlistDefinitionSongs[i].pdid === props.rowData.pdid) {
                if(value !== _playlistDefinitionSongs[i][props.field]){
                    _playlistDefinitionSongs[i][props.field] = value;
                    setPlaylistDefinitionSongs(_playlistDefinitionSongs);
                }
                break;
            }
        }
    }

    const nrRepsEditor = (props, field) => {
        return(<div className="flex flex-wrap gap-1 pt-2 align-items-center">
            <InputNumber
                value={props.rowData[field]} onValueChange={(e) => onEditorValueChange(props, e.target.value)}
                showButtons
                buttonLayout="vertical"
                mode="decimal" min={1} max={50} step={1}/>
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded" onClick={() => deleteSelectedSong(props.rowData)} />
            </React.Fragment>
        </div>)
    }

    const loadPlaylistFromSpotifyAsSelection = () => {
        if(spotifyPlaylistSongSelection !== null) {
            songservice.loadPlaylist(spotifyPlaylistSongSelection).then(data => {
                if(data["detail"]) {
                    toast.current.show({
                        severity:'error',
                        summary: 'Playlist Not Found',
                        detail: 'Spotify: playlist link or ID. Apple Music: ID starting with pl. or catalog link (via playlist share), the library link will not work.',
                        life: 6000})
                } else {
                    let addPlDef = data["playlist_definition"]
                    let _songs = songs;
                    let _playlistDefinitionSongs = playlistDefinitionSongs;

                    for (let i = 0; i < addPlDef.length; i++) {
                        let track_id = addPlDef[i]["song"].id;
                        let songInDefinition = _playlistDefinitionSongs.find(pds => pds.song.id === track_id);
                        if(songInDefinition) {
                            _playlistDefinitionSongs = _playlistDefinitionSongs.filter(pds => pds.song.id !== track_id);
                            _playlistDefinitionSongs.push({pdid: songInDefinition.id, song: songInDefinition.song, nr_reps: songInDefinition.nr_reps + addPlDef[i]["nr_reps"]* nrRepsPl});
                        } else {
                            _playlistDefinitionSongs.push({pdid: addPlDef[i]["song"]["id"], song: addPlDef[i]["song"], nr_reps: addPlDef[i]["nr_reps"]* nrRepsPl});
                        }
                        _songs = _songs.filter(item => item.id !== track_id);
                    }
                   //let _playlistDefinitionSongs = [...playlistDefinitionSongs, ...addPlDef];
                    setPlaylistDefinitionSongs(_playlistDefinitionSongs);
                    setSongs(_songs);

                    let _removed_tracks = data["removed_tracks"];
                    if (_removed_tracks.length > 0) {
                        toast.current.show({
                            severity: 'warn',
                            summary: (_removed_tracks.length + " tracks were not supported and dropped"),
                            detail: 'e.g. ' + _removed_tracks[0]["main_artist"] + " - " + _removed_tracks[0]["title"],
                            life: 6000
                        })
                    }
                }
            })
        }
    }

    const loadPlaylistFromSpotify = (spotifyplaylistid) => {
        if(playlistDefinitionSongs.length > 0){
            toast.current.show({severity:'error', summary: 'Playlist not loaded', detail:'Already songs selected. Clear selection before initializing with a playlist.', life: 3000});
        }
        else
        {
            songservice.loadPlaylist(spotifyplaylistid).then(data => {
                if(data["detail"]) {
                    toast.current.show({
                        severity:'error',
                        summary: 'Playlist Not Found',
                        detail: 'Spotify: playlist link or ID. Apple Music: ID starting with pl. or catalog link (via playlist share), the library link will not work.',
                        life: 6000})
                } else {
                    let _playlistDefinitionSongs =[...data["playlist_definition"]];
                    setPlaylistDefinitionSongs(_playlistDefinitionSongs);
                    //setPlaylist(data["playlist"])
                    let _removed_tracks = data["removed_tracks"];
                    if(_removed_tracks.length > 0){
                        toast.current.show({severity:'warn', summary: (_removed_tracks.length +" tracks were not supported and dropped"), detail:'e.g. ' + _removed_tracks[0]["main_artist"] + " - " + _removed_tracks[0]["title"], life: 6000})
                    }
                    //setPlaylistPreviewCollapsed(false);
                }

            })
        }
    }

    const showDurationColumn = ()=>{
        if(showDurationCol){
            return(<Column key={"song.duration_ms"} field="song.duration_ms" header={"Duration"} body={durationTemplate} />)
        }
    }

    return(
		<div>
            <Toast ref={toast} />
            <Panel header="Playlist Definition" toggleable>
                <Fieldset className={"p-0"} legend={"Load an Existing Playlist"} hidden={playlistDefinitionSongs.length > 0}>
                    <div className="p-0">
                        You can load all songs of an existing playlist (only BTS and members songs are loaded) and use it as a starting point to generate your own. (available as long as no songs selected yet)
                    </div>
                    <div className="flex flex-wrap gap-1 pt-2">
                        <InputText className={""} value={spotifyInitializerPlaylist}
                                   onChange={(e) => setSpotifyInitializerPlaylist(e.target.value)}
                                   placeholder={"Spotify / Apple Music playlist link or id"}
                                   style={{width: '290px'}}/>
                        <Button label={"Load Playlist"} onClick={() => loadPlaylistFromSpotify(spotifyInitializerPlaylist)} disabled={(spotifyInitializerPlaylist === '')}/>
                    </div>
                </Fieldset>
                <Fieldset className={"p-0"} legend={"Song Selection"}>
                    <div hidden={playlistDefinitionSongs.length === 0}>
                        <DataTable value={playlistDefinitionSongs} dataKey="pdid" editMode="cell" removableSort defaultSortOrder={-1}>
                            <Column field="song.image_url" body={imageTemplate2} header={<span>
                                <Button style={{padding: 0, margin:0}} icon="pi pi-clock" text onClick={(e) => setShowDurationCol(!showDurationCol)} /> </span>
                            } ></Column>
                            {showDurationColumn()}
                            <Column field="song.nameconcat" sortable header={"Artists-Song"}></Column>
                            <Column field="nr_reps" header="#" sortable editor={(props) => nrRepsEditor(props, "nr_reps")}></Column>
                        </DataTable>
                        <div className="flex flex-wrap gap-1 pt-2">
                            <Button className="mt-2" label="Clear All / Reset" onClick={clearPlaylistDefinition} aria-label="Submit" disabled={playlistDefinitionSongs.length === 0}  />
                            <div className="simple-text">
                                {playlistDefinitionPlayistSongs()} songs / {playlistDefinitionSongs.filter(plDefItem => plDefItem.nr_reps !== 0).length} unique
                                ({playlistDefinitionDuration()})
                            </div>
                        </div>
                    </div>
                    <div className="card flex flex-wrap gap-1 pt-2">
                        <AutoComplete
                            value={selectedSong}
                            suggestions={filteredSongs}
                            completeMethod={searchSong}
                            field="nameconcat" dropdown
                            placeholder="Select a song"
                            itemTemplate={itemTemplate}
                            onChange={(e) => setSelectedSong(e.value)}
                            aria-label="Songs" dropdownAriaLabel="Select Song"
                            style={{width: '290px'}}/>
                        <InputNumber inputId="repSong"
                                     value={nrReps} onValueChange={(e) => setNrReps(e.value)}
                            showButtons
                            mode="decimal" min={1} max={50} step={1}/>
                        <Button icon={"pi pi-add"} label="Add Song" aria-label="Submit" onClick={() => addSelectedSong()} />
                    </div>
                    <div className="card flex flex-wrap gap-1 mt-2">
                        <AutoComplete
                            value={selectedAlbum}
                            suggestions={filteredAlbums}
                            completeMethod={searchAlbum}
                            field="nameconcat" dropdown
                            placeholder="Select an album"
                            itemTemplate={itemTemplate}
                            onChange={(e) => setSelectedAlbum(e.value)}
                            aria-label="Albums" dropdownAriaLabel="Select Album"
                            style={{width: '290px'}}/>
                        <InputNumber inputId="repAlbum"
                                     value={nrRepsAlbum} onValueChange={(e) => setNrRepsAlbum(e.value)}
                                     showButtons
                                     mode="decimal" min={1} max={50} step={1}/>
                        <Button label="Add Album's Songs" aria-label="Submit" onClick={() => addSelectedAlbum()} />
                    </div>
                    <div className="card flex flex-wrap gap-1 mt-2">
                        <InputText value={spotifyPlaylistSongSelection}
                                   onChange={(e) => setSpotifyPlaylistSongSelection(e.target.value)}
                                   placeholder={"Spotify playlist link or id"}
                                   style={{width: '290px'}}/>
                        <InputNumber inputId="repPl"
                                     value={nrRepsPl} onValueChange={(e) => setNrRepsPl(e.value)}
                                     showButtons
                                     mode="decimal" min={1} max={50} step={1}/>
                        <Button label="Add Playlist's Songs"
                                disabled ={spotifyPlaylistSongSelection === ''}
                                onClick={(e) => loadPlaylistFromSpotifyAsSelection()}  />
                    </div>
                </Fieldset>

                {/* max_duration_ms: 1000*maxDurationS,
                    exclude_skit: excludeSkit,
                    nr_songs_by_member: nrSongsByMember,
                    minimum_nr_songs_bts: minNrSongsBTS*/}
                <Fieldset className="p-0 mb-2" legend="Filler Parameters" toggleable={true}>
                    <div>
                        If parameters are left as is, random songs by BTS are used as fillers. Songs specified above also count towards the minimum number of songs by members / BTS.
                    </div>
                    <div className="flex-wrap gap-1 pt-2">
                        <span className="span-label">Min. Nr Songs by Members</span>
                        <InputNumber inputId="nrSongsByMember"
                                     value={nrSongsByMember} onValueChange={(e) => setNrSongsByMember(e.value)}
                                     showButtons
                                     mode="decimal" min={0} max={10} step={1}/>
                    </div>
                    <div className="flex-wrap gap-1 pt-2">
                        <span className="span-label">Min. Nr Songs by BTS</span>
                        <InputNumber inputId="minNrSongsBTS"
                                     value={minNrSongsBTS} onValueChange={(e) => setMinNrSongsBTS(e.value)}
                                     showButtons
                                     mode="decimal" min={0} max={100} step={1}/>
                    </div>
                    <div className="flex-wrap pt-2">
                        <span className="span-label">Maximum Song Duration</span>
                        <Dropdown value={maxTimeInMs}
                                  onChange={(e) => setMaxTimeInMs(e.value)}
                                  options={deltaOptions} optionLabel="name" optionValue="value"/>
                    </div>
                    {/*<span>{durationFromMs(getMaxDurationMS())}</span><div className="flex-wrap gap-1 pt-2">*/}
                    {/*    <span style={{width: '210px', display: 'inline-block'}}/><span>02:30</span><span style={{width: '100px', display: 'inline-block'}}/><span>10:00</span>*/}
                    {/*        <Slider value={deltaTimeIn5s} onChange={(e) => setDeltaTimeIn5s(e.value)}*/}
                    {/*            max={90} style={{display: "inline-block"}} className={'pl-7 flex w-14rem'}/>*/}
                    {/*</div>*/}
                    <div className="flex-wrap gap-1 pt-3">
                        <span className="span-label">Exclude Skits</span>
                        <Checkbox onChange={e => setExcludeSkit(e.checked)} checked={excludeSkit}></Checkbox>
                    </div>
                </Fieldset>

                {/*<TreeSelect value={selectedNodeKey2} options={albums} onChange={(e) => setSelectedNodeKey2(e.value)} filter placeholder="Select Items"></TreeSelect>*/}
                <Fieldset className="p-0 mb-2" legend="Generator Parameters" toggleable={true}>
                    <span className="span-label">Min. Distance to Same Song</span>
                    <InputNumber inputId="generatorDeltaSong"
                                 value={plGenDeltaSong} onValueChange={(e) => setPlGenDeltaSong(e.value)}
                                 showButtons
                                 mode="decimal" min={1} max={20} step={1}/>
                    <br/>
                    <span className="span-label">Generation Method</span>
                    <Dropdown className="generator-drop-down" value={plGenMethod} options={plGenMethodOptions}
                              onChange={(e ) => setPlGenMethod(e.value) } optionLabel="displayval"
                              placeholder="Select a method"/>
                </Fieldset>
                    <Button label="Generate Playlist" onClick={() => generatePlaylist()} aria-label="Submit" disabled={playlistDefinitionSongs.length === 0}  />


            </Panel>
            <Panel header="Preview, Adapt and Save Playlist" toggleable collapsed={playlistPreviewCollapsed} onToggle={(e) => setPlaylistPreviewCollapsed(e.value)}>
                <Fieldset className="p-0 mb-2" legend="Playlist Info">
                    <div className="flex-wrap">
                        <span className={'span-label-short'}>Song Distribution</span>
                        <Button className="in-text-button"  type="button" icon="pi pi-chart-bar" text style={{padding:'0px'}}
                                onClick={(e) => op.current.toggle(e)}/>
                        <OverlayPanel ref={op}>
                            <SongDistributionChart playlist={playlist}/>
                        </OverlayPanel>
                    </div>
                    <div className="flex-wrap pt-2">
                        <span className={'span-label-short'}>Length</span>
                        <span>{playlist.length} ({Math.max(0, playlist.length-playlistDefinitionPlayistSongs())} filler songs added)</span>
                    </div>
                    <div className="flex-wrap pt-2">
                        <span className={'span-label-short'}>Duration</span>
                        <span>{playlistTime(playlist)}</span>
                    </div>
                    <div className="flex-wrap pt-2">
                        <span className={'span-label-short'}>Link to playlist</span>
                        <span hidden={playlistURL !== null && playlistURL !== ''}>Playlist not saved yet!</span>
                        <span><a href={playlistURL}>{playlistURL}</a>
                        <Button className="in-text-button" visible={playlistURL !== null} size={"small"} icon="pi pi-external-link"
                            label={"Open Playlist in new Tab"} text aria-label="OpenPlaylistNewTab" onClick={() => {
                            let win = window.open(playlistURL, '_blank');
                            win.focus();
                        }}/></span>
                    </div>
                </Fieldset>

                <Fieldset className="p-0 mb-2" legend={"Save Playlist"} >
                    {/*<span>Spotify: Playlist will be saved to this</span>*/}
                    {/*    <Button className="in-text-button" size={"small"} icon="pi pi-external-link"*/}
                    {/*        label={"public spotify profile"} text aria-label="OpenSpotifyProfileNewTab" onClick={() => {*/}
                    {/*    let win = window.open("https://open.spotify.com/user/31yn3xhhdaqqkzg53leh3wjmyjsi", '_blank');*/}
                    {/*    win.focus();*/}
                    {/*}}/>*/}
                    <div>Apple Music: you have to connect your AM account, in order to save playlists there.</div>

                   <PlaylistSaveToStreamingService spotifyUsers={spotifyUsers} playlist={playlist}
                                                   editInfo={editInfo} setEditInfo={setEditInfo}
                                                   buttonsDisabled={buttonsDisabled} setButtonsDisabled={setButtonsDisabled}
                                                   onSaved={(url) => {setPlaylistURL(url); incrementPlaylistCounter(); setButtonsDisabled(true);}}/>
                </Fieldset>

                <Fieldset className="p-0 mb-2" legend={"Preview (reordering possible)"}>
                    <PlaylistDualView playlist={playlist} setPlaylist={(pl) => setPlaylist(pl)}/>
                </Fieldset>
            </Panel>
		</div>

	)
}

	